import { useMemo } from "react";

import { useStore } from "../../stores/StoreContext";
import { ChatService } from "../LogicServices/ChatService";

export function useChatService(): ChatService {
  const storeContext = useStore();
  return useMemo(() => new ChatService(storeContext), [storeContext]);
}
